module.exports = __webpack_public_path__ + "static/media/logo137.d1b503e2.png";